module.exports = __webpack_public_path__ + "media/images/riders/SINA_FREI-b1d34f1e661dffea34c1776ee7efc841.png";